import {
  colors,
  typography,
  H2,
  Button,
  mediaQueries,
  size,
} from '@everlywell/leaves';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Title = styled(H2)`
  margin: 0 auto;
  text-align: center;

  ${mediaQueries.forDesktopUp} {
    max-width: 685px;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${size.md}px;
  margin: ${size.lg}px 0 ${size.sm}px 0;

  ${mediaQueries.forTabletHorizontalUp} {
    gap: ${size.lg}px;
    margin: ${size.xl1}px 0 ${size.lg}px 0;
  }

  ${mediaQueries.forDesktopUp} {
    > div {
      max-width: 427px;
    }
  }
`;

export const SubHeadline = styled.p`
  ${typography.bodyTextSmall};
  color: ${colors.gray4};
  text-align: center;
`;

export const LinkWrapper = styled.div`
  ${typography.bodyTextSmall};
  text-align: center;

  a {
    color: ${colors.green4};
    text-decoration: none;

    :hover,
    :active {
      text-decoration: underline;
    }
  }
`;

export const HorizontalLine = styled.hr`
  border: none;
  border-bottom: 1px solid ${colors.green4};
  width: 100%;
  margin: ${size.lg}px 0;

  ${mediaQueries.forTabletHorizontalUp} {
    width: 50%;
  }
`;

export const DisclaimerText = styled.p`
  ${typography.bodyTextSmall};
  text-align: center;
`;

export const Cta = styled(Button)`
  min-width: 100%;
  margin-top: ${size.xl1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    min-width: 500px;
  }
`;

export const ExtraInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${size.md} 0 ${size.xl1} 0;
  padding-bottom: ${size.xl4}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: ${size.xl1}px;
  }

  ${mediaQueries.forDesktopUp} {
    max-width: 690px;
    margin: 0 auto;
  }
`;
